import React, { useMemo, useState } from "react";
import { Box, CircularProgress, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import FormTreeNav from "../FormTreeNav";

/**
 * 좌측 양식 목록.
 *
 * 양식이 7종일 때는 카드 그리드가 한눈에 들어왔지만 19종이 되면서 스크롤이 길어졌다.
 * 그래서 사이드바 + 검색 + 폴더로 바꿨다 — 목록을 계속 보면서 오른쪽에서 작성할 수 있다.
 *
 * 폴더 묶는 규칙은 {@link ../formTree} 에 있고 관리자 화면과 같은 것을 쓴다.
 */
export default function FormSidebar({ groups, loading, selectedCode, onSelect }) {
    const [q, setQ] = useState("");

    const filtered = useMemo(() => {
        const kw = q.trim().toLowerCase();
        if (!kw) return groups;
        return (groups || [])
            .map((g) => ({ ...g, forms: g.forms.filter((f) => f.name.toLowerCase().includes(kw)) }))
            .filter((g) => g.forms.length > 0);
    }, [groups, q]);

    return (
        <Box sx={{
            width: 280, flexShrink: 0, borderRight: "1px solid #e2e8f0",
            display: "flex", flexDirection: "column", bgcolor: "#f8fafc",
        }}>
            <Box sx={{ p: 1.5, borderBottom: "1px solid #e2e8f0" }}>
                <TextField
                    size="small" fullWidth placeholder="양식 검색"
                    value={q} onChange={(e) => setQ(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchRoundedIcon sx={{ fontSize: 18, color: "#94a3b8" }} />
                            </InputAdornment>
                        ),
                        sx: { bgcolor: "#fff", fontSize: 13 },
                    }}
                />
            </Box>

            <Box sx={{ flex: 1, overflowY: "auto", py: 1 }}>
                {loading && (
                    <Stack alignItems="center" sx={{ py: 4 }}><CircularProgress size={22} /></Stack>
                )}

                {!loading && filtered.length === 0 && (
                    <Typography sx={{ px: 2, py: 3, fontSize: 12.5, color: "#94a3b8", textAlign: "center" }}>
                        {q ? "검색 결과가 없습니다." : "상신할 수 있는 양식이 없습니다."}
                    </Typography>
                )}

                <FormTreeNav
                    groups={filtered}
                    keyOf={(f) => f.code}
                    selected={selectedCode}
                    onSelect={onSelect}
                    query={q}
                />
            </Box>
        </Box>
    );
}
